import React from 'react'
import { Tile, TileCaption, TileImage } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import Image from 'components/LegacyImage'
import { STATIC_IMAGE_BASE } from 'libs/constants'

export const HeroContainer = ({ children }: { children?: React.ReactNode }) => {
  const { t } = useTranslation('@mc/next')

  const imageAlt = t('guestPassRecipient.hero.a11y.imageAlt')

  return (
    <div className='mc-bg-gray-100'>
      <div className='d-block d-md-none'>
        <Tile aspectRatio='9x16'>
          <TileImage
            image={
              <Image
                alt={imageAlt}
                src={`${STATIC_IMAGE_BASE}/gp_recipient_hero_mobile.png`}
                priority
                layout='fill'
                objectFit='contain'
                objectPosition='bottom'
              />
            }
          />

          <TileCaption position='center top'>{children}</TileCaption>
        </Tile>
      </div>
      <div className='d-none d-md-block d-lg-none'>
        <Tile aspectRatio='4x3'>
          <TileImage
            image={
              <Image
                alt={imageAlt}
                src={`${STATIC_IMAGE_BASE}/gp_recipient_hero_tablet.png`}
                priority
                layout='fill'
                objectFit='contain'
              />
            }
          />

          <TileCaption position='center top'>{children}</TileCaption>
        </Tile>
      </div>
      <div className='d-none d-lg-block d-xl-none'>
        <Tile aspectRatio='4x3'>
          <TileImage
            image={
              <Image
                alt={imageAlt}
                src={`${STATIC_IMAGE_BASE}/gp_recipient_hero_desktop.png`}
                priority
                layout='fill'
                objectFit='contain'
              />
            }
          />

          <TileCaption position='center top'>{children}</TileCaption>
        </Tile>
      </div>
      <div className='d-none d-xl-block'>
        <Tile aspectRatio='21x9'>
          <TileImage
            image={
              <Image
                alt={imageAlt}
                src={`${STATIC_IMAGE_BASE}/gp_recipient_hero_desktop.png`}
                priority
                layout='fill'
                objectFit='contain'
              />
            }
          />

          <TileCaption position='center top'>{children}</TileCaption>
        </Tile>
      </div>
    </div>
  )
}
